import React from "react";
import PropTypes from "prop-types";
import Form from "../common/Form";
import Section from "../common/Section";
import TextInput from "../common/TextInput";
import TextAreaInput from "../common/TextAreaInput";
import Dropdown from "../common/Dropdown";
import Button from "../common/Button";
import Fieldset from "../common/Fieldset";
import Row from "../common/Row";
import Marker from "../common/Marker";
import RadioButtonGroup from "../common/RadioButtonGroup";
import CheckBoxWithChild from "../common/CheckBoxWithChild";
import FieldsetSubHeader from "../common/FieldsetSubHeader";
import NieuwbouwInfrastructurenTable from "./NieuwbouwInfrastructurenTable";
import RenovatieInfrastructurenTable from "./RenovatieInfrastructurenTable";
import VerdwijnendeInfrastructurenTable from "./VerdwijnendeInfrastructurenTable";
import Map from "../common/map/Map";
import Markers from "../common/map/Markers";
import ValidationGroup from "../common/ValidationGroup";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import * as domainConstants from "../../constants/DomainConstants";

const ProjectForm = (props) => {
	const {
		project,
		postcodes,
		gemeenten,
		soortenInfrastructuur,
		soortenInfrastructuurAll,
		disabled,
		errors,
		onChange,
		onEditNieuwbouw,
		onDeleteNieuwbouw,
		onEditRenovatie,
		onChangeAdres,
		onAddNieuwbouwInfrastructuur,
		onAddRenovatieInfrastructuur,
		onChangeRenovatieTable,
		onChangeVerdwijnendeInfrasTable,
		onGetGeoCoordinates,
		onSave,
		color,
		mapKey,
		onChangeSoortDossier,
		onReplacePoint,
		saveNewPoint,
		cancelReplace,
		inEditMode,
		newCoords,
		maxMapFeaturesToLoad,
		osmBaseLayerUrl,
		onMarkerDragEnd,
		validationMessageType
	} = props;

	const typeDossier = project.typeDossier;

	const DOSSIERNAAM_TOOLTIP = "Een dossiernaam bestaat uit de naam van de sportinfrastructuur. Bijvoorbeeld: S&R Olympia of Euro Volley Center. ";

	const hasCoordinates = project.breedtegraad && project.lengtegraad;

	function mapOnGetGeoCoordinates() {
		return onGetGeoCoordinates(event);
	}

	const onClickTooltip = (i) => {
		return function (value) {
			return props.onClickTooltip(value, i);
		};
	};

	const mijnProject = <Marker lat={parseFloat(inEditMode ? newCoords.lat : project.breedtegraad)} color="orange" lng={parseFloat(inEditMode ? newCoords.lng : project.lengtegraad)} />;
	const WIJZIG_MAP = "Druk op wijzig om de locatie van het project te wijzigen.";

	if (project.sportinfrastructurenOpKaart == null) {
		project.sportinfrastructurenOpKaart = [];
	}

	if (project.sportinfrastructurenInDeBuurt == null) {
		project.sportinfrastructurenInDeBuurt = [];
	}

	const sportInfrastructurenNieuwbouw = project.sportinfrastructurenInDeBuurt.filter(i => i.soortWerken === domainConstants.INFRASTRUCTUUR_TYPE.NIEUWBOUW);
	const sportInfrastructurenRenovatie = project.sportinfrastructurenInDeBuurt.filter(i => i.soortWerken !== domainConstants.INFRASTRUCTUUR_TYPE.NIEUWBOUW);
	const isNieuwbouw = project.soortDossier !== null && (project.soortDossier.toString() === domainConstants.DOSSIER_SOORT_NIEUWBOUW.toString() || project.soortDossier.toString() === domainConstants.DOSSIER_SOORT_NIEUWBOUWRENOVATIE.toString());
	const isRenovatie = project.soortDossier !== null && (project.soortDossier.toString() === domainConstants.DOSSIER_SOORT_RENOVATIE.toString() || project.soortDossier.toString() === domainConstants.DOSSIER_SOORT_NIEUWBOUWRENOVATIE.toString());
	const rozeInfras = project.sportinfrastructurenOpKaart.filter(s => (s.deelVanAanvraag != null && s.deelVanAanvraag !== undefined && (s.deelVanAanvraag.toString() === domainConstants.DeelVanAanvraag.Ja.toString())) || (!s.deelVanAanvraag == null || s.deelVanAanvraag == undefined));
	const blauweInfras = project.sportinfrastructurenOpKaart.filter(s => s.deelVanAanvraag != null && s.deelVanAanvraag !== undefined && (s.deelVanAanvraag.toString() === domainConstants.DeelVanAanvraag.Nee.toString() || s.deelVanAanvraag.toString() === domainConstants.DeelVanAanvraag.Reconversie.toString() && !rozeInfras.find(r => r.naam === s.naam)));

	const markersToShow = [];

	let ulProps = {
		style: {
			"list-style-type": "none",
			"font-size": "14px"
		}
	};

	blauweInfras.forEach((sportinfrastructuur) => {
		if (sportinfrastructuur.breedtegraad && sportinfrastructuur.lengtegraad) {
			const namen = [...new Set(project.sportinfrastructurenOpKaart.filter(s => (s.lengtegraad === sportinfrastructuur.lengtegraad && s.breedtegraad === sportinfrastructuur.breedtegraad))
				.map(x => x.naam))];
			const tooltipText = <div><ul {...ulProps}>{namen.map(n => <li key={`${n}_Key`}>{n}</li>)}</ul></div>;

			markersToShow.push({
				lat: parseFloat(sportinfrastructuur.breedtegraad),
				long: parseFloat(sportinfrastructuur.lengtegraad),
				tooltip: tooltipText,
				size: 'x-large',
				color: types.COLOR_BLUE
			});
		}
	});

	markersToShow.push(
		{
			lat: parseFloat(inEditMode ? newCoords.lat : project.breedtegraad),
			long: parseFloat(inEditMode ? newCoords.lng : project.lengtegraad),
			size: 'x-large',
			color: types.COLOR_ORANGE,
			draggable: inEditMode,
			onDragEnd: onMarkerDragEnd
		}
	);

	rozeInfras.forEach((sportinfrastructuur) => {
		if (sportinfrastructuur.breedtegraad && sportinfrastructuur.lengtegraad) {
			const namen = [...new Set(project.sportinfrastructurenOpKaart.filter(s => (s.lengtegraad === sportinfrastructuur.lengtegraad && s.breedtegraad === sportinfrastructuur.breedtegraad))
				.map(x => x.naam))];
			const tooltipText = <div><ul {...ulProps}>{namen.map(n => <li key={`${n}_Key`}>{n}</li>)}</ul></div>;

			markersToShow.push({
				lat: parseFloat(sportinfrastructuur.breedtegraad),
				long: parseFloat(sportinfrastructuur.lengtegraad),
				tooltip: tooltipText,
				size: 'x-large',
				color: types.COLOR_PINK
			});
		}
	});

	const mijnProjectMarkers = <Markers markersToShow={markersToShow} />;
	const customBounds = markersToShow.map(m => [m.lat, m.long]);

	const soortDossierProps = {
		disabled: disabled,
		label: "Soort werken",
		value: project.soortDossier,
		name: "soortDossier",
		labelInside: true,
		horizontal: true,
		items: [
			{ value: domainConstants.DOSSIER_SOORT_NIEUWBOUW, label: 'Nieuwbouw' },
			{ value: domainConstants.DOSSIER_SOORT_RENOVATIE, label: 'Renovatie' },
			{ value: domainConstants.DOSSIER_SOORT_NIEUWBOUWRENOVATIE, label: "Nieuwbouw + Renovatie" }],
		itemsLocked: [
			{ locked: (sportInfrastructurenRenovatie.length > 0 && sportInfrastructurenRenovatie.filter(x => x.deelVanAanvraag.toString() === "0").length > 0), text: "De optie nieuwbouw kan niet geselecteerd worden want er werden reeds renovatie infrastructuren aangeduid of toegevoegd." },
			{ locked: (sportInfrastructurenNieuwbouw.length > 0), text: "De optie renovatie kan niet geselecteerd worden want er werden reeds nieuwbouwinfrastructuren toegevoegd." },
			{ locked: false, text: "" }
		],
		onChange: onChangeSoortDossier,
		validationMessage: errors ? errors["soortDossier"] : '',
		validationMessageType: validationMessageType
	};

	const verdwijnenErInfrastructurenProps = {
		disabled: disabled,
		label: "Zullen er bestaande sportinfrastructuren verdwijnen door de geplande werkzaamheden?",
		value: project.verdwijnenErInfrastructuren,
		labelInside: true,
		horizontal: true,
		tooltip: "Duid “ja” aan indien sportinfrastructuur fysiek verdwijnt en niet meer zal worden geëxploiteerd.",
		name: "verdwijnenErInfrastructuren",
		items: [{ label: "Ja", value: "true" }, { label: "Nee", value: "false" }],
		onChange: onChange,
		lockedText: "Het antwoord op deze vraag kan niet gewijzigd worden wanneer er al verdwijnende infrastructuren werden aangeduid.",
		locked: (project.verdwijnenErInfrastructuren &&
			(project.sportinfrastructurenInDeBuurt.filter(x => x.deelVanAanvraag.toString() === "2").length > 0 ||
				(sportInfrastructurenRenovatie.filter(x => !!x.spakki).length > 0 && project.verdwijnenErInfrastructurenNietInSpakki)))
	};

	const betrekkingTotInrichtingTopSportInfraProps = {
		disabled: disabled,
		label: "Heeft deze subsidieaanvraag uitsluitend betrekking op de inrichting van de topsporttrainingsinfrastructuur ?",
		value: project.uitsluitendInrichtingVanTopsportInfrastructuren,
		labelInside: true,
		horizontal: true,
		name: "uitsluitendInrichtingVanTopsportInfrastructuren",
		items: [{ label: "Ja", value: "true" }, { label: "Nee", value: "false" }],
		onChange: onChange,
		validationMessage: errors ? errors["uitsluitendInrichtingVanTopsportInfrastructuren"] : '',
		validationMessageType: validationMessageType
	};

	return (<Section
		title="Vul het antwoord op onderstaande vragen in"
		color={color}>
		<Form
			title="Invulformulier project"
			name="project"
			onRightButtonClick={onSave}
			rightButtonDisabled={disabled || inEditMode}
			rightButtonLabel="Bewaar"
		>
			<Fieldset title="Identificatie van het project">
				{project.dossierNummer ? <TextInput
					label="Dossiernummer"
					name="dossiernummer"
					onChange={onChange}
					value={project.dossierNummer}
					disabled
					maxLength={100}
				/> : ''}
				<TextInput
					label="Naam van het project"
					name="naam"
					value={project.naam}
					disabled={disabled}
					onChange={onChange}
					validationMessage={errors ? errors.naam : ''}
					validationMessageType={validationMessageType}
					tooltip={DOSSIERNAAM_TOOLTIP}
					maxLength={100}
				/>
				<TextAreaInput
					label="Omschrijving"
					name="omschrijving"
					disabled={disabled}
					value={project.omschrijving}
					onChange={onChange}
					height={4}
					validationMessage={errors ? errors.omschrijving : ''}
					validationMessageType={validationMessageType}
					maxLength={500}
				/>
				<RadioButtonGroup {...soortDossierProps} />
				<RadioButtonGroup {...verdwijnenErInfrastructurenProps} />
				{typeDossier === domainConstants.DOSSIER_TYPE_AANVRAAG_TOPSPORT_NIEUWBOUW || typeDossier === domainConstants.DOSSIER_TYPE_AANVRAAG_TOPSPORT_RENOVATIE ?
					<RadioButtonGroup {...betrekkingTotInrichtingTopSportInfraProps} /> : ''}
			</Fieldset>
			<div id="adres">
				<Fieldset title="Adres en ligging van het project">
					<TextInput
						label="Straat en huisnummer"
						name="straatHuisnummer"
						disabled={disabled}
						value={project.straatHuisnummer}
						onChange={onChangeAdres}
						size={12}
						validationMessage={errors ? errors.straatHuisnummer : ''}
						validationMessageType={validationMessageType}
						maxLength={200}
					/>
					<Row>
						<Dropdown
							label="Postcode"
							name="postcode"
							onChange={onChangeAdres}
							value={project.postcode}
							size={4}
							items={postcodes}
							disabled={disabled}
							validationMessage={errors ? errors.postcode : ''}
							validationMessageType={validationMessageType}
							noResultsMessage="Tik (2 cijfers) en zoek"
						/>
						<Dropdown
							label="Gemeente"
							name="gemeente"
							onChange={onChangeAdres}
							disabled={disabled}
							value={project.gemeente}
							size={8}
							items={gemeenten}
							validationMessage={errors ? errors.gemeente : ''}
							validationMessageType={validationMessageType}
						/>
					</Row>
					<Row>
						<Button disabled={disabled || inEditMode} text="Positioneer op kaart" className="o-col-4" style={{ marginLeft: '0.8333%', marginRight: '0.8333%', marginTop: '0.8333%' }} onClick={mapOnGetGeoCoordinates} />

						<ValidationGroup
							cols={8}
							colsBefore={4}
							validationMessages={errors ? errors.hasCoordinatenLigging : undefined}
							validationMessageType={validationMessageType}>
							<TextInput
								label="breedtegraad"
								onChange={() => { }}
								disabled
								size={errors && errors.hasCoordinatenLigging ? 6 : 4}
								value={project.breedtegraad}
								name="breedtegraad" />
							<TextInput
								label="lengtegraad"
								onChange={() => { }}
								disabled
								size={errors && errors.hasCoordinatenLigging ? 6 : 4}
								value={project.lengtegraad}
								name="lengtegraad" />
						</ValidationGroup>

						{hasCoordinates ?
							<div>
								<Fieldset>
									<Row>
										<Map
											mapName={mapKey}
											maxMapFeaturesToLoad={maxMapFeaturesToLoad}
											baseLayerUrl={osmBaseLayerUrl}
											baseLayerAttribution='&copy; <a href="https://openstreetmap.org">OpenStreetMap</a> contributors, Tiles courtesy of <a href="https://geo6.be/">GEO-6</a>'
											children={mijnProjectMarkers}
											zoom={12}
											showEmptyMap
											hideLegende
											onlyBaseLayers
											customBounds={customBounds}
										/>
									</Row>
									<Row><br />
										{inEditMode === false ? <span><Button onClick={onReplacePoint} text={'Wijzig ligging op kaart'} disabled={disabled} /> <Tooltip text={WIJZIG_MAP} zIndex={1000} tooltipType={types.TOOLTIP_INFO} windowWidth={35} windowAlignRight={false} /></span> : ''}
										{inEditMode === true ? <Button onClick={saveNewPoint} text={'Bewaar'} disabled={disabled} /> : ''}
										{inEditMode === true ? <Button onClick={cancelReplace} text={'Annuleer'} disabled={disabled} /> : ''}
									</Row>
								</Fieldset>
								{isNieuwbouw || isRenovatie ?
									<Fieldset title="Sportinfrastructuren in het project" >
										{isNieuwbouw ? <div>
											<ValidationGroup
												cols={12}
												colsBefore={4}
												validationMessages={errors ? errors.sportInfrastructurenNieuwbouw : undefined}
												validationMessageType={validationMessageType} >
												<FieldsetSubHeader>Nieuwbouw</FieldsetSubHeader>
												<p>
													Bevat uw project werkzaamheden aan de randaccomodatie van een bestaande openlucht sportinfrastructuur (vb. bouwen van kleedkamers,
													plaatsen van omheiningen of verlichtingspalen) dan is dit geen nieuwbouw maar moeten deze werkzaamheden opgegeven worden als
													renovatiewerkzaamheden aan de bestaande openlucht sportinfrastructuur.
												</p><br />
												{sportInfrastructurenNieuwbouw.length > 0 ?
													<NieuwbouwInfrastructurenTable
														infrastructurenInDeBuurt={sportInfrastructurenNieuwbouw}
														disabled={disabled || inEditMode}
														onChange={onChange}
														onEdit={onEditNieuwbouw}
														onDelete={onDeleteNieuwbouw}
														soortenInfrastructuur={soortenInfrastructuur}
														soortenInfrastructuurAll={soortenInfrastructuurAll}
													/> : <br />}
												<Row>
													<Button text="Voeg nieuwbouw sportinfrastructuur toe" className="o-col-6" disabled={disabled || inEditMode} onClick={onAddNieuwbouwInfrastructuur} />
												</Row><br />
											</ValidationGroup></div> : null}
										{isRenovatie ? <div>
											<ValidationGroup
												cols={12}
												colsBefore={4}
												validationMessages={errors ? errors.sportInfrastructurenRenovatie : undefined}
												validationMessageType={validationMessageType}>
												<FieldsetSubHeader>Renovatie</FieldsetSubHeader>
												{sportInfrastructurenRenovatie.length > 0 ?
													<p>
														De sportinfrastructuren die opgenomen zijn in onze sportdatabank en die zich bevinden in de buurt van het opgegeven adres, zijn weergegeven op de kaart en in de tabel.
														<div style={{ fontWeight: "bold" }}>Duid hieronder aan welke sportinfrastructuren je gaat renoveren in het project waarvoor je de subsidie aanvraagt.</div>
														Pas op! Deze sportinfrastructuren moeten op hetzelfde adres liggen.
													</p>
													: <p>
														Er werden in onze sportdatabank geen sportinfrastructuren gevonden die zich bevinden in de buurt van het opgegeven adres.
														<div style={{ fontWeight: "bold" }}>Voeg hier de bestaande sportinfrastructuur toe die je gaat renoveren in het project waarvoor je de subsidie aanvraagt.</div>
													</p>
												}
												{sportInfrastructurenRenovatie.length > 0 ?
													<RenovatieInfrastructurenTable
														infrastructurenInDeBuurt={sportInfrastructurenRenovatie}
														disabled={disabled || inEditMode}
														onChange={onChangeRenovatieTable}
														onEdit={onEditRenovatie}
														soortenInfrastructuur={soortenInfrastructuur}
														soortenInfrastructuurAll={soortenInfrastructuurAll}
													/> : <br />}
												<Row>
													<Button text="Voeg ontbrekende sportinfrastructuur toe" className="o-col-6" disabled={disabled || inEditMode} onClick={onAddRenovatieInfrastructuur} />
												</Row>
											</ValidationGroup></div> : null}

									</Fieldset>
									: null}
								{project.verdwijnenErInfrastructuren.toString() !== "false" && sportInfrastructurenRenovatie && sportInfrastructurenRenovatie.filter(x => !!x.spakki).length > 0 ?
									<ValidationGroup
										cols={12}
										colsBefore={4}
										validationMessages={errors ? errors.verdwijnendeInfrastructuren : undefined}
										validationMessageType={validationMessageType}>
										<Fieldset title="Bestaande sportinfrastructuren die zullen verdwijnen" >
											<VerdwijnendeInfrastructurenTable
												infrastructuren={sportInfrastructurenRenovatie.filter(x => !!x.spakki)}
												onChange={onChangeVerdwijnendeInfrasTable}
												soortenInfrastructuur={soortenInfrastructuur}
												soortenInfrastructuurAll={soortenInfrastructuurAll}
											/>
											<CheckBoxWithChild
												name={"verdwijnenErInfrastructurenNietInSpakki"}
												label={"De bestaande sportinfrastructuren die verdwijnen staan niet in de bovenstaande lijst."}
												value={project.verdwijnenErInfrastructurenNietInSpakki}
												onChange={onChange}
											/>
										</Fieldset>
									</ValidationGroup>
									: null}
							</div>
							: null}
					</Row>
				</Fieldset>
			</div>
		</Form>
	</Section >);
};

ProjectForm.propTypes = {
	project: PropTypes.object.isRequired,
	gemeenten: PropTypes.array.isRequired,
	postcodes: PropTypes.array.isRequired,
	soortenInfrastructuur: PropTypes.array.isRequired,
	soortenInfrastructuurAll: PropTypes.array.isRequired,
	onChange: PropTypes.func.isRequired,
	onEditNieuwbouw: PropTypes.func.isRequired,
	onDeleteNieuwbouw: PropTypes.func.isRequired,
	onEditRenovatie: PropTypes.func.isRequired,
	onChangeAdres: PropTypes.func.isRequired,
	onAddNieuwbouwInfrastructuur: PropTypes.func.isRequired,
	onAddRenovatieInfrastructuur: PropTypes.func.isRequired,
	onChangeRenovatieTable: PropTypes.func.isRequired,
	onChangeVerdwijnendeInfrasTable: PropTypes.func.isRequired,
	onGetGeoCoordinates: PropTypes.func.isRequired,
	onChangeSoortDossier: PropTypes.func.isRequired,
	onSave: PropTypes.func.isRequired,
	color: PropTypes.string.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	hasUnsavedChanges: PropTypes.bool,
	mapKey: PropTypes.string,
	inEditMode: PropTypes.bool,
	currentSportinfrastructurenInDeBuurtIndex: PropTypes.number,
	currentSportinfrastructuurInDeBuurt: PropTypes.object,
	onReplacePoint: PropTypes.func,
	saveNewPoint: PropTypes.func,
	cancelReplace: PropTypes.func,
	newCoords: PropTypes.object,
	maxMapFeaturesToLoad: PropTypes.string,
	osmBaseLayerUrl: PropTypes.string,
	onMarkerDragEnd: PropTypes.func,
	validationMessageType: PropTypes.string
};

export default ProjectForm;
